import React from 'react';
import {
    IconButton,
    Tooltip,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Typography,
    Box
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import { useLanguage } from '../../state/context/language.context';

const LanguageToggle = () => {
    const { currentLanguage, changeLanguage, isEnglish, isChinese } = useLanguage();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageSelect = (language) => {
        changeLanguage(language);
        handleClose();
    };

    const languages = [
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'zh', name: '中文', flag: '🇨🇳' }
    ];

    return (
        <>
            <Tooltip title="Language / 语言">
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{
                        ml: 1,
                        color: 'inherit',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        }
                    }}
                    aria-controls={open ? 'language-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <LanguageIcon />
                </IconButton>
            </Tooltip>

            <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'language-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {languages.map((language) => (
                    <MenuItem
                        key={language.code}
                        onClick={() => handleLanguageSelect(language.code)}
                        selected={currentLanguage === language.code}
                        sx={{
                            minWidth: 120,
                            '&.Mui-selected': {
                                backgroundColor: 'rgba(25, 118, 210, 0.12)',
                            }
                        }}
                    >
                        <ListItemIcon>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="body1">{language.flag}</Typography>
                                {currentLanguage === language.code && (
                                    <CheckIcon fontSize="small" color="primary" />
                                )}
                            </Box>
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant="body2">
                                {language.name}
                            </Typography>
                        </ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default LanguageToggle;
